import React from 'react';
import { useTranslation } from '@app/core/i18n';

import { DropDownList, DropDownListProps } from '@ast/magma/components/dropdownlist';

import {
  Country,
  countries,
} from '@app/common/utils/countries';

import { FlagIcon } from '../../FlagIcon';

import styles from './CountrySelectorControl.pcss';
import { CountrySelectorItem } from './CountrySelectorItem';
import { searchFilter } from './utils';

/**
 * Component props.
 */
export type CountrySelectorControlProps = Omit<DropDownListProps<any, any>, 'data' | 'onChange'> & {
  onChange: (country: Country) => void;
};

/**
 * Returns icon for selected item.
 */
const getItemIcon = (item: Country) => item && (
  <FlagIcon
    className={styles.flagIcon}
    country={item.countryCode}
  />
);

/**
 * Returns label for selected item.
 */
const getItemLabel = (item: Country) => item && item.dialCode;

/**
 * Represents the CountrySelectorControl component.
 */
export const CountrySelectorControl = (props: CountrySelectorControlProps) => {
  const { t } = useTranslation();

  return (
    <DropDownList
      data-stable-name="CountrySelector"
      data={countries}
      searchLabel={t(
        'country-selector-control.search-input.label|Countries dropdown search input label',
        'Search',
      )}
      searchFilter={searchFilter}
      getItemIcon={getItemIcon}
      getItemLabel={getItemLabel}
      itemRenderer={CountrySelectorItem}
      searchEnabled
      hideItemIcon
      showButtonIcon
      {...props}
    />
  );
};
